import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../../../api/pickupOrderRemote';

import TruckerRecordInfo from './TruckerRecordInfo';

import ApiResponse from '../../../../../models/ApiResponse';
import ResponseError from '../../../../../models/ResponseError';
import PickupOrderGha from '../../../../../models/PickupOrderGha';

import truckerRecordInfoStyles from './truckerRecordInfo.module.css';
import commonStyles from '../../../../common/common.module.css';

interface TruckerRecordInfoContainerProps {
  truckerInfo: {
    driverName: string;
    driverId: string | null;
    maskedDriverId: string | null;
    driverIDType: string | null;
    matchingPhoto: boolean | null;
  };
  selectedDooNumber: string;
  disabled: boolean;
  receiveError: (error: ResponseError) => void;
};

interface TruckerRecordInfoContainerState {
  truckerInfo: {
    driverName: string;
    driverId: string | null;
    maskedDriverId: string | null;
    driverIDType: string | null;
    matchingPhoto: boolean | null;
  };
};

class TruckerRecordInfoContainer extends Component<TruckerRecordInfoContainerProps, TruckerRecordInfoContainerState> {

  state: TruckerRecordInfoContainerState = {
    truckerInfo: {
      driverName: '',
      driverId: null,
      maskedDriverId: null,
      driverIDType: null,
      matchingPhoto: null
    }
  }

  componentDidMount() {

    if (this.props.truckerInfo) {
      this.setState({ truckerInfo: this.props.truckerInfo });
    }
  }

  componentDidUpdate(prevProps: TruckerRecordInfoContainerProps) {
    
    if (prevProps.truckerInfo !== this.props.truckerInfo) {
      this.setState({ truckerInfo: this.props.truckerInfo });
    }
  }

  handleChange = (propertyName: string, event: any): void => {

    const value: string = event.target.value;
    const truckerInfo: { driverName: string; driverId: string | null; maskedDriverId: string | null; driverIDType: string | null; matchingPhoto: boolean | null; } = { ...this.state.truckerInfo };

    switch (propertyName) {

      case 'driverId': 
      truckerInfo.driverId = value; 
      truckerInfo.maskedDriverId = value; 
      break;
      case 'driverIDType': truckerInfo.driverIDType = value; break;
      case 'driverName': truckerInfo.driverName = value; break;
      default: break;
    }

    this.setState({ truckerInfo });
  }

  setMatchingPhoto = (value: boolean | null ):void => {
    const truckerInfo: { driverName: string; driverId: string | null; maskedDriverId: string | null; driverIDType: string | null; matchingPhoto: boolean | null; } = { ...this.state.truckerInfo };
    
    truckerInfo.matchingPhoto = value;

    this.doSaveGhaExportDriverInfo(this.props.selectedDooNumber, { matching_photo: truckerInfo.matchingPhoto });

    this.setState({ truckerInfo });
  }
  
  loseFocus = (propertyName: string): void => {
    const bodyObject: any = {};
    const truckerInfo: { driverName: string; driverId: string | null; maskedDriverId: string | null; driverIDType: string | null; matchingPhoto: boolean | null; } = { ...this.state.truckerInfo };
    
    switch (propertyName) {

      case 'driverId': 
        bodyObject['driver_id'] = this.state.truckerInfo.driverId;
        truckerInfo.maskedDriverId = (truckerInfo.driverId) ? truckerInfo.driverId.replace(/.(?=.{4,}$)/g, '#') : truckerInfo.driverId;
        this.setState({ truckerInfo });
      break;
      case 'driverIDType': bodyObject['driver_id_type'] = this.state.truckerInfo.driverIDType; break;
      case 'driverName': bodyObject['driver_name'] = this.state.truckerInfo.driverName; break;
      default: break;
    }

    this.doSaveGhaExportDriverInfo(this.props.selectedDooNumber, bodyObject);
  }

  handleClick = (propertyName: string) => {
    const key: string = propertyName;
    const truckerInfo: { driverName: string; driverId: string | null; maskedDriverId: string | null; driverIDType: string | null; matchingPhoto: boolean | null; } = { ...this.state.truckerInfo };
    if(key === 'driverId') {
      truckerInfo.maskedDriverId = truckerInfo.driverId;
      this.setState({ truckerInfo });
    }
  }

  doSaveGhaExportDriverInfo = (dooNumber: string, bodyObject: any): void => {

    pickupOrderRemote.saveGhaExportDriverInfo(dooNumber, bodyObject).then((resp: ApiResponse<PickupOrderGha>) => {

      const error: ResponseError | undefined = resp.error;
      
      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render () {

    return (
      <div className={ `${ commonStyles.wrapper } ${ truckerRecordInfoStyles.wrapper }` } >

        <h3 className={ commonStyles.header } >Truckers Record Of ID</h3>
        <TruckerRecordInfo
          truckerInfo={ this.state.truckerInfo }
          setMatchingPhoto={ this.setMatchingPhoto }
          handleChange={ this.handleChange }
          loseFocus={ this.loseFocus }
          handleClick={ this.handleClick }
          disabled={ this.props.disabled }
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(TruckerRecordInfoContainer);